import { ModalComponent, ModalResult } from '@michelin/theme';
import { TranslationService } from '../translations/services/translation.service';
import { TemplateRef } from '@angular/core';

export function canDeactivateForm(
  isFormChanged: () => boolean,
  unsavedChangesModal: ModalComponent,
  unsavedChangesContentModal: TemplateRef<any>,
  translationService: TranslationService,
  onCancel?: () => void
): Promise<boolean> | boolean {
  if (isFormChanged()) {
    unsavedChangesModal.open({
      id: 'unsaved-confirmation',
      width: 600,
      title: translationService.translate('discardChangesText'),
      content: unsavedChangesContentModal,
      confirm: translationService.translate('okText'),
      cancel: translationService.translate('cancelLinkText')
    });

    return new Promise<boolean>((resolve) => {
      unsavedChangesModal.result.subscribe((result: ModalResult) => {
        // When modal is closed without confirmation (cancel button or X)
        if (result === undefined || !result.result) {
          if (onCancel) {
            onCancel();
          }
          return resolve(false);
        }
        // When modal is confirmed
        resolve(true);
      });
    });
  }
  return true;
}
